document.addEventListener("DOMContentLoaded", function (event) {
    "use strict";

    function resizeTextAreas() {
        $('[data-max-text-lines]').each(function () {
            var $txtContainer = $(this);

            var currentHeight = $txtContainer.height();
            var lineHeight = parseFloat($txtContainer.css('line-height'));
            var numberOfLines = parseFloat($txtContainer.attr('data-max-text-lines'));
            var desiredHeight = numberOfLines * (lineHeight - 1);

            $txtContainer.css('height', desiredHeight);

            if (currentHeight > desiredHeight) {
                $txtContainer        
                    .css('overflow', 'hidden')
                    .attr('title', $txtContainer.text());
            }
        });
    }

    $(window).resize(function() {
        resizeTextAreas();
    });

    resizeTextAreas();
});